export default{
	contactsUs:{
		mr:'李先生',
		contacts:'联系人',
		contact:'联系我们',
		submitBtn:'提交',
		userName:'姓名',
		tel:'电话',
		email:'邮箱',
		remark:'备注',
		company:'公司名称',
		welcome:'欢迎各界人士前来洽谈合作',
		message:'一条留言、一封邮件或许正是成就一个好产品的开始。把您的需求告诉我们，我们将以快速准确的予以回复，将在30分 钟内通过您留下的联系方式与您取得联系，给与报价!'
	},
	
	portfolio:{
		productsTitle1:'智慧金融',
		productsTitle2:'智慧医疗',
		productsTitle3:'智慧气象',
		productsTitle4:'智慧交通',
		productsTitle5:'智慧电商',
		productsTitle6:'智慧城市',
	},
	serve:{
		business:'服务业务',
		title1:'企业产品定制',
		title2:'互联网项目对外投资',
		title3:'技术团队合作战略',
		title4:'互联网产品研发、设计',
		title5:'互联网人才、团队输出',
		title6:'企业定向培养人才'
	},
	serviceProcess:{
		process:'服务流程',
		service:'移动互联顾问、一站式服务'
	},
	company:{
		service:'APP开发  •  小程序开发  •  PC系统开发  •  PC网站开发  •  微信公众号开发',
		tips:'最专业的企业移动解决方案提供商'
	},
	appName:'成都麦之芽科技有限公司',
	detail:'详情',
	view:'查看',
	language:'en'
	
}